import React, {useState} from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {CheckBox} from '@priority-software/priority-style-react';
import {onSaveChanges} from '../../actions';
import {FormInputComponent} from '../../../../Input';
import {fieldValue} from '../../../../../../../stores/Form/Field';
import {Column} from '../../../../../../../stores/Form/Column';
import {Record} from '../../../../../../../stores/Form/Record';
import {createDataTestId} from '../../../../../../../utils/dataTestId';

type InputProps = {
    column: Column;
    record: Record;
    initialValue: fieldValue;
};

export const InputField = ({column, record, initialValue}: InputProps) => {
    const [value, setValue] = useState(initialValue);

    const handleChange = v => {
        setValue(v);
    };

    const toggleChecked = () => {
        setValue(prev => !prev);
    };

    const onBlur = async () => {
        if (initialValue !== value) {
            await onSaveChanges(column.Name, record, value);
        }
    };

    if (column.Type === priority.netitems.form.ColumnType.Boolean) {
        return (
            <CheckBox
                {...createDataTestId(`checkbox`, true)}
                checked={value as boolean}
                onChange={toggleChecked}
                onBlur={onBlur}
                disabled={column.isReadonly || record.parentForm.isReadonly}
            />
        );
    } else {
        return (
            <FormInputComponent
                column={column}
                searchMode={false}
                rowIndex={null}
                value={value}
                handleKeyDown={e => null}
                handleChange={handleChange}
                inputRef={null}
                isActive={false}
                processEventCodes={null}
                setMaxWidthMode={null}
                setEditMode={a => null}
                onFocus={null}
                onBlur={onBlur}
            />
        );
    }
};
